import React from 'react';
import { Box, Typography, Card, CardContent, Divider, TextField, Grid } from '@mui/material';

function SalesActionStatDetailCard({ selectedDetail }) {

    const handleProjectClick = (selectedDetail) => {
        if (!selectedDetail || !selectedDetail.prjUuid || String(selectedDetail.prjUuid).trim() === '' || String(selectedDetail.prjUuid) === 'null') return;

        let pageUrl = "/chancemng";

        const status = selectedDetail.cmpStatus;
        const hasStatus = status !== null && status !== undefined && String(status).trim() !== '' && String(status) !== 'null';

        let stepTarget = (selectedDetail.cstGrade !== null && selectedDetail.cstGrade !== undefined && String(selectedDetail.cstGrade) !== 'null') ? selectedDetail.cstGrade : '0';
        if (hasStatus) {
            if (String(selectedDetail.prjTyp).trim() === 'N') {
                pageUrl = "/projectmng";
            } else {
                pageUrl = "/maintancetmng";
            }
            stepTarget = (selectedDetail.cmpGrade !== null && selectedDetail.cmpGrade !== undefined && String(selectedDetail.cmpGrade) !== 'null') ? selectedDetail.cmpGrade : '0';
        }
        
        window.open(`${pageUrl}/${selectedDetail.prjUuid}/${stepTarget}/1`, '_blank');
    };

  const inputStyle = {
    '& .MuiInputBase-input': { fontSize: '13px', color: '#1F2937', fontWeight: '500' },
    '& .MuiInputLabel-root': { fontSize: '13px' },
    backgroundColor: '#ffffff'
  };

  const textareaStyle = {
    '& .MuiInputBase-input': { fontSize: '13px', color: '#374151', lineHeight: '1.6' },
    '& .MuiInputLabel-root': { fontSize: '13px' },
    backgroundColor: '#ffffff'
  };

  return (
    <Card 
      elevation={0}
      sx={{ 
        borderRadius: '12px', 
        border: '1px solid rgba(0, 0, 0, 0.08)', 
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
        backgroundColor: '#ffffff',
        minHeight: 280,
        height: '100%',
        mt: 0 
      }}
    >
      <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.2, height: '100%', boxSizing: 'border-box' }}>

        <Typography variant="subtitle1" sx={{ fontWeight: '600', color: '#111827' }}>
          상세 내역
        </Typography>
        <Divider sx={{ mb: 0.5 }} />
        
        {selectedDetail ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth size="small" label="제목" value={selectedDetail.title || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" label="업무구분" value={selectedDetail.actionName || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" label="담당자명" value={selectedDetail.usrNm || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" label="시작 시간" value={selectedDetail.startDatetime ? selectedDetail.startDatetime.substring(0, 16) : '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" label="종료 시간" value={selectedDetail.endDatetime ? selectedDetail.endDatetime.substring(0, 16) : '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" label="업체명" value={selectedDetail.companyNm || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" label="장소" value={selectedDetail.meetPlace || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>

            <Grid item xs={12}>
                <TextField 
                    fullWidth 
                    size="small" 
                    label="사업명" 
                    value={selectedDetail.cstNm || ''} 
                    InputProps={{ readOnly: true }} 
                    focused={false} 
                    onClick={() => handleProjectClick(selectedDetail)}
                    sx={{
                      '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                      '& .MuiInputLabel-root': { fontSize: '13px' },
                      '& .MuiInputBase-input': {
                          fontSize: '13px',
                          cursor: 'pointer !important',
                          color: '#228be6 !important', 
                          fontWeight: '600 !important',
                          textDecoration: 'underline !important',
                          WebkitTextFillColor: '#228be6 !important',
                          pointerEvents: 'auto !important'
                      },
                      backgroundColor: '#ffffff'
                    }} 
                />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth multiline rows={20} size="small" label="상세 내용" value={selectedDetail.actionContent || '-'} InputProps={{ readOnly: true }} sx={textareaStyle} focused={false} />
            </Grid>
          </Grid>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexGrow: 1, minHeight: 690 }}>
            <Typography variant="body2" color="text.disabled" sx={{ textAlign: 'center', lineHeight: 1.6 }}>
              테이블의 행을 클릭하면<br />상세 입력 폼 형태 리포트가<br />여기에 표시됩니다.
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default SalesActionStatDetailCard;
